export default {
  text: 'white',
  primary: '#c9ac39',
  secondary: '#64001f',
  background: 'black',
  backgroundSecondary: '#1d1c1c',
  light: '#FFF',
  dark: '#202020'
}
